import { gridSize } from '@atlassian/jira-common-styles/src';

export const HEIGHT: number = gridSize * 8;
export const NAME = 'ANNOUNCEMENT' as const;
